<template>
    <span>
        <span v-if="status === 'published'">
            <status-indicator type="success" :beacon="true"></status-indicator> Online
        </span>
        <span v-else-if="status === 'expired'">
            <status-indicator type="danger"></status-indicator> Udløbet
        </span>
        <span v-else-if="status === 'draft'">
            <status-indicator type="default"></status-indicator> Kladde
        </span>
    </span>
</template>

<script type="text/babel">
export default {
    props: ['campaign'],
    computed: {
        status() {
            return this.campaign.status
        },
    },
}
</script>
